import { render } from "./Home.vue?vue&type=template&id=1914512a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=1914512a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1914512a"

export default script